
import {computed, defineComponent, h, unref} from 'vue';
import {TYPES, TYPE_BOOTSTRAP} from './types';
import * as SVGs from './map';
import SVGLoader from '@ohrm/oxd/core/components/Icon/SVGLoader.vue';

export default defineComponent({
  name: 'oxd-icon',

  props: {
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: TYPE_BOOTSTRAP,
      validator: (value: string) => {
        return TYPES.indexOf(value) !== -1;
      },
    },
  },

  setup(props) {
    const classes = computed(() => {
      return {
        'oxd-icon': true,
        [`bi-${props.name}`]: props.type === TYPE_BOOTSTRAP,
      };
    });

    return () =>
      props.type === TYPE_BOOTSTRAP
        ? h('i', {class: unref(classes)})
        : h(
            SVGLoader,
            {class: unref(classes)},
            {default: () => h(SVGs[props.name])},
          );
  },
});
